import { formatCurrency } from '../../../utils/formatCurrency';
import {
  computeMaxAffordableAmount,
  isOverAffordableLimit,
} from '../../../utils/bankPaymentAffordability';

export interface BankPaymentAmountHintsProps {
  rail: 'eft' | 'payshap';
  amount: number;
  availableBalance: number;
  feeAmount?: number | null;
  totalDebit?: number | null;
  quoteLoading?: boolean;
}

export function BankPaymentAmountHints({
  rail,
  amount,
  availableBalance,
  feeAmount,
  totalDebit,
  quoteLoading = false,
}: BankPaymentAmountHintsProps) {
  const hasQuote = typeof feeAmount === 'number' && feeAmount > 0;
  const fee = hasQuote ? feeAmount : null;
  const total = hasQuote && typeof totalDebit === 'number'
    ? totalDebit
    : (fee !== null && amount > 0 ? amount + fee : null);
  const maxAffordable = fee !== null
    ? computeMaxAffordableAmount(availableBalance, fee)
    : null;
  const overLimit = fee !== null && amount > 0 && total !== null
    ? isOverAffordableLimit(amount, total, availableBalance)
    : false;

  const railName = rail === 'payshap' ? 'Instant Payment' : 'Standard EFT';

  return (
    <div
      className="space-y-1 mt-2"
      style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '12px' }}
    >
      {quoteLoading && (
        <p style={{ color: '#6b7280', margin: 0 }}>Loading fee estimate…</p>
      )}
      {!quoteLoading && hasQuote && feeAmount != null && (
        <p style={{ color: '#6b7280', margin: 0 }}>
          {railName} fee: <strong style={{ color: '#1f2937' }}>{formatCurrency(feeAmount)}</strong>
          {amount > 0 && total !== null && (
            <>
              {' · '}Total debit: <strong style={{ color: '#1f2937' }}>{formatCurrency(total)}</strong>
            </>
          )}
        </p>
      )}
      {!quoteLoading && !hasQuote && (
        <p style={{ color: '#6b7280', margin: 0 }}>
          A transaction fee applies to {railName.toLowerCase()} transfers. Your total debit includes the fee.
        </p>
      )}
      {maxAffordable !== null && availableBalance > 0 && (
        <p style={{ color: overLimit ? '#b45309' : '#6b7280', margin: 0, fontWeight: overLimit ? 600 : 400 }}>
          {overLimit ? 'Amount exceeds available balance after fee. ' : ''}
          Maximum you can send: <strong>{formatCurrency(maxAffordable)}</strong>
        </p>
      )}
    </div>
  );
}
